import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h4 className="text-lg font-heading font-bold mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">
                  黑料网永久域名
                </Link>
              </h4>
              <p className="text-sm text-foreground-300 leading-relaxed">
                黑料网永久域名官方入口，汇总最新、最全的黑料网域名地址，确保您随时畅通访问。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold mb-4 text-foreground-200">快速导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
                <Link to="/category/yule-bagua" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">分类浏览</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
                <a href="#domain-list" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">最新域名</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold mb-4 text-foreground-200">热门分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/yule-bagua" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">娱乐八卦</Link>
                <Link to="/category/shehui-redian" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">社会热点</Link>
                <Link to="/category/wangluo-chigua" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">网络吃瓜</Link>
                <Link to="/category/keji-shuma" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">科技数码</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold mb-4 text-foreground-200">联系方式</h4>
              <div className="flex flex-col gap-2 text-sm text-foreground-300">
                <span>邮箱：support@heiliaowang.com</span>
                <span>更新频率：每日更新</span>
                <span>服务时间：7×24小时</span>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2026 黑料网永久域名. All rights reserved.
            </p>
            <p className="text-xs text-foreground-400">
              本站仅提供域名导航服务，不存储任何用户数据
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}